"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToMbits = exports.algorithmChoice = exports.incrementId = void 0;
var lastId = 0;
var incrementIdPrefix = 'id-';
var incrementId = function (reset) {
    if (reset === void 0) { reset = false; }
    if (reset) {
        lastId = 0;
    }
    lastId += 1;
    return "".concat(incrementIdPrefix).concat(lastId);
};
exports.incrementId = incrementId;
var algorithmChoice = function (algorithm, openWsConnections, openHttpConnections, preferredType, maxHttpConnections) {
    if (algorithm === void 0) { algorithm = 'mixed'; }
    if (openWsConnections === void 0) { openWsConnections = 0; }
    if (openHttpConnections === void 0) { openHttpConnections = 0; }
    if (preferredType === void 0) { preferredType = null; }
    if (maxHttpConnections === void 0) { maxHttpConnections = 8; }
    if (algorithm === 'onlyHttp') {
        return 'http';
    }
    if (algorithm === 'onlyWebsockets' || openHttpConnections >= maxHttpConnections) {
        return 'websocket';
    }
    if (algorithm === 'mixed' && !preferredType) {
        return openHttpConnections < openWsConnections ? 'http' : 'websocket';
    }
    if (algorithm === 'mixed' && preferredType) {
        return preferredType;
    }
    if (algorithm === 'preferHttp' && preferredType !== 'websocket') {
        return 'http';
    }
    if (algorithm === 'preferWebsockets' && preferredType !== 'http') {
        return 'websocket';
    }
    return preferredType || 'websocket';
};
exports.algorithmChoice = algorithmChoice;
var convertToMbits = function (speedInBytesPS) {
    if (!speedInBytesPS) {
        return 0;
    }
    var speedInBitsPS = speedInBytesPS * 8;
    return (speedInBitsPS / 1000) / 1000;
};
exports.convertToMbits = convertToMbits;
//# sourceMappingURL=helpers.js.map